export function sanitiseDisplay(text: string): string {
  let out = text;
  for (const { re, to } of REPLACEMENTS) out = out.replace(re, to);
  return out;
}

export function sanitiseOptions<T extends { label: string; description?: string }>(
  options: T[],
): T[] {
  return options.map((o) => {
    const label = sanitiseDisplay(o.label);
    const description =
      o.description === undefined ? o.description : sanitiseDisplay(o.description);
    if (label === o.label && description === o.description) return o;
    return { ...o, label, description };
  });
}

const SEED_MARKER = /\s*\[demo-seed[^\]]*\]/g;

const REPLACEMENTS: ReadonlyArray<{ re: RegExp; to: string }> = [{ re: SEED_MARKER, to: "" }];
